import LazyImage from "../../web/components/common/LazyImage";

export default function CompanyHero({ company }) {
  return (
    <div
      class="hero-image"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${company.cover_url}"`,
      }}
    >
      <div class="hero-text">
        <LazyImage
          src={company.avatar_url}
          className="avatar rounded h-100px mb-2"
          placeholder="/assets/company-placeholder.png"
        />
        <h1>{company.name}</h1>
        <p>{company.slogan}</p>
      </div>
    </div>
  );
}
